export const projects = [
  {
    id: 2,
    img: "eyadstore.png",
    link: "https://eyad-store.vercel.app/",
  },
  {
    id: 1,
    img: "Amazon.png",
    link: "https://eyadadel.github.io/Amazon/",
  },
  {
    id: 3,
    img: "walmart.png",
    link: "https://github.com/EyadAdel",
  },
];
